<transition :name="name" @enter="enter" @after-enter="afterEnter" @leave="leave" @after-leave="afterLeave"><slot></slot></transition>